import React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';

import type { RootState } from 'reducers/types';
import { getCurrency } from 'selectors';
import { formatAmount } from 'utils/money';

import { Round } from './Round/Round';

export type FormattedAmountProps = ConnectedProps<typeof connector> & {
  currency: string;
  render?: (formattedAmount: { formattedAmount: string }) => React.ReactNode;
  value: number;
};

const FormattedAmountComponent = ({
  getCurrency,
  currency,
  render,
  value,
}: FormattedAmountProps) => {
  const currencyObject = getCurrency(currency);
  if (!currencyObject) {
    return null;
  }
  const formattedAmount = formatAmount(value, currencyObject);

  return render && typeof render === 'function'
    ? render({ formattedAmount })
    : formattedAmount;
};

FormattedAmountComponent.Round = Round;

const mapStateToProps = (state: RootState) => ({
  getCurrency: (code: string) => getCurrency(state, code),
});

const connector = connect(mapStateToProps);

const FormattedAmount = connector(FormattedAmountComponent);

export { FormattedAmount };
